import React from 'react';

const AddTicket = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sticky Header */}
      <div className="sticky top-7 bg-white shadow-md p-4 z-10">
        <div className="flex items-center space-x-2">
          <input
            type="text"
            placeholder="Search tickets..."
            className="flex-grow px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition">
            Search
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-4">
        <h1 className="text-2xl font-bold">Ticket</h1>
        {/* Add more content here */}
      </div>
    </div>
  );
}

export default AddTicket;